// AI Generated Component
import { Component, EventEmitter, Input, OnInit } from '@angular/core';
import { MonNumberPipe } from '@client/app/filters/mon-number.pipe';
import { MonUtilsService } from '@client/app/blocks/service/mon-utils/mon-utils.service';

@Component({
    selector: 'table-css-compliance',
    standalone: false,
    template: `
        <div class="table-css-compliance d-flex justify-content-center">
            <div>
                <a [attr.aria-disabled]="!hasAction()"
                   class="btn btn-border-radius button-monsido-icon pt-1 pb-0 pl-0 pr-2 text-right"
                   role="button"
                   [class.nohover]="!hasAction()"
                   (click)="runAction()">
                    <div class="page-count">
                        {{ getPercentage(true) }}
                    </div>
                    <div class="page-text hidden-print" translate>
                        Compliance
                    </div>
                </a>
            </div>
           <mon-simple-doughnut-chart
                [percentage]="getPercentageAsNumber()"
           ></mon-simple-doughnut-chart>
        </div>
    `,
})
export class TableCssComplianceComponent implements OnInit {
    @Input() totalCount: number = 0;
    @Input() errorCount: number = 0;
    @Input() monAction = new EventEmitter();

    constructor (
        private monNumberPipe: MonNumberPipe,
        private monUtilsService: MonUtilsService,
    ) {}

    ngOnInit (): void {
        this.totalCount = this.totalCount || 0;
        this.errorCount = this.errorCount || 0;
    }

    getPercentage (decimals: boolean): number | string {
        let percentage = 0;
        if (this.totalCount !== 0) {
            percentage = (1 - this.errorCount / this.totalCount);
        }

        if (!decimals) {
            return percentage;
        } else {
            return this.monNumberPipe.transform(this.monUtilsService.withinHundred(percentage), '0.[00]%');
        }
    }

    getPercentageAsNumber (): number {
        return this.getPercentage(false) as number;
    }

    runAction (): void {
        if (this.hasAction()) {
            this.monAction.emit();
        }
    }

    hasAction (): boolean {
        return typeof this.monAction === 'function';
    }
}
